import { environment } from '@/environments/environment';
import { AppInitializationContext } from '@/models/app-initialization-context';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppContextService {
  constructor(private httpClient: HttpClient) {}

  loadAppContext(userIdPId: string | null) {
    const url = new URL('context', environment.serviceEndpoints.ftConnect);
    if (userIdPId !== null) {
      url.searchParams.append('userIdPId', userIdPId);
    }

    return this.httpClient.get<AppInitializationContext>(url.toString());
  }
}
